module.exports = __webpack_public_path__ + "static/img/king_card_1.3b80698.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/en/king_card_1.png
// module id = Hi5J
// module chunks = 0